import { ReactNode } from 'react';
import styled from 'styled-components';

import { S26 } from '@sorare/core/src/atoms/icons/S26';
import { SorareLogo } from '@sorare/core/src/atoms/icons/SorareLogo';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandM, BrandXL } from '@sorare/core/src/atoms/typography';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';

const Root = styled(Vertical)`
  padding-bottom: var(--double-unit);
`;

type Props = {
  overline: ReactNode;
  title: ReactNode;
};
export const QuickPlayTutorialHeader = ({ overline, title }: Props) => {
  const isTabletAndAbove = useIsTabletAndAbove();

  return (
    <Root gap={4} center>
      <Horizontal>
        <SorareLogo size="medium" />
        <S26 size={5} />
      </Horizontal>
      <Vertical center>
        {!!isTabletAndAbove && (
          <BrandM color="var(--c-nd-600)">{overline}</BrandM>
        )}
        {isTabletAndAbove ? (
          <BrandXL>{title}</BrandXL>
        ) : (
          <BrandM>{title}</BrandM>
        )}
      </Vertical>
    </Root>
  );
};
